export default{
  navlangs: ['us','fr','cn','sx','br','au','in','sg']
}
